import { useEffect } from "react";

/**
 * Hook: Detect clicks outside of a referenced element
 * @param {React.RefObject} ref - The element to detect outside clicks for
 * @param {Function} onOutsideClick - Callback when an outside click happens
 */
const useClickOutside = (ref, onOutsideClick) => {
  useEffect(() => {
    const handleClick = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        onOutsideClick?.(event);
      }
    };

    document.addEventListener("mousedown", handleClick);
    return () => {
      document.removeEventListener("mousedown", handleClick);
    };
  }, [ref, onOutsideClick]);
};

export default useClickOutside;

